/** Values must match backend `Tradeball.Constants` / Laravel enums — confirm if labels look wrong. */
export enum AccountDeactivatingStatus {
    ActiveBets = 1,
    Statement = 2,
}
